export class CarBrand {
    id: number;
    name: string;
}